import { render, staticRenderFns } from "./TranslationEditModal.vue?vue&type=template&id=69ab147e"
import script from "./TranslationEditModal.vue?vue&type=script&lang=ts"
export * from "./TranslationEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports